import { PlusCircle } from "react-bootstrap-icons";
import { AsyncButton, AsyncButtonProps } from "../controls";
import { useBeFigure } from "./BeFigureContextProvider";
import { BeFigureAddOperations } from "./functions/interface";

export interface AddNewButtonProps extends AsyncButtonProps {
  operation: BeFigureAddOperations;
  newLength: number;
  label?: string;
}

/**
 * Add new data row button component
 *
 * @param props - Destructured parameter object
 * @param props.operation - The operation type for adding a new data row
 * @param props.newLength - The new length of data rows after addition
 * @param props.label - Optional label for the button
 */
export const AddNewButton = ({
  operation,
  newLength,
  label = "Add",
  ...rest
}: AddNewButtonProps) => {
  const { dispatch } = useBeFigure();

  return !dispatch ? null : (
    <AsyncButton
      onClick={() =>
        dispatch({
          operation,
          newLength,
        })
      }
      className="my-2 d-flex align-items-center btn btn-sm btn-success justify-content-center"
      {...rest}
    >
      <span className="me-2">{label}</span>
      <PlusCircle />
    </AsyncButton>
  );
};

AddNewButton.displayName = "AddNewButton";
